import { render, staticRenderFns } from "./compButton.vue?vue&type=template&id=658ff804&"
import script from "./compButton.vue?vue&type=script&lang=js&"
export * from "./compButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports